import React, { ReactElement, useCallback } from 'react';
import AddFirstWidgetResult from 'adapter/in/dashboards/pages/EditDashboard/AddFirstWidgetResult';
import { dispatchDashboardEdit } from 'adapter/in/dashboards/context/EditDashboard';

const AddFirstWidgetResultContainer = (): ReactElement => {
    const { setShowSidePanelMenu } = dispatchDashboardEdit();
    const handleSidePanelMenu = useCallback(() => setShowSidePanelMenu(true), []);
    return <AddFirstWidgetResult onAddWidget={handleSidePanelMenu} />;
};

export default AddFirstWidgetResultContainer;
